import { useQueryClient } from "@tanstack/react-query"

import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

import { horizontalSigningQueryKeys } from "../queries/horizontalSigning/queryKeys"

import { useHorizontalSigningMutation } from "./useHorizontalSigningMutation"

export function useHorizontalSignCreate(
    queryParameters,
    config = {},
) {
    const url = "horizontal_signs/"
    const queryClient = useQueryClient()

    return useHorizontalSigningMutation(
        url,
        axiosInstance.post,
        {
            ...queryParameters,
        },
        {
            ...config,
            onSuccess: (data) => {
                queryClient.invalidateQueries({ queryKey: horizontalSigningQueryKeys.project() })
                queryClient.invalidateQueries({ queryKey: horizontalSigningQueryKeys.layer() })
                queryClient.invalidateQueries({ queryKey: horizontalSigningQueryKeys.stats_categories() })
                queryClient.invalidateQueries({ queryKey: horizontalSigningQueryKeys.stats_conditions() })
                config.onSuccess?.(data)
            },
        },
    )
}